import React, { useState } from "react";
import { Contentdiv, MainDiv, MainSection, TextBoxDiv } from "./elements";
import { textBox2 } from "assets";
import { Image } from "react-bootstrap";
import { MainContainer } from "components/common";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";

const FaqComp = () => {
  const faqdata = [
    {
      id: 1,
      number: "1",
      question: "What are Elemental Legends NFTs?",
      answer: `In the RetroCraft metaverse, the Elemental Legends NFT collection has sparked a gaming renaissance. Five legendary beings, embodying Fire, Water, Wood, Metal, and Earth, now stand at the centre of an epic quest. \n Each Elemental Legend reveals two distinct trait classes – the dazzling Golden Traits and the crystalline elegance of Diamond Traits. As enthusiasts stake these legends, they unlock Voxel Energy Tokens (VET),  fueling their journey in the pixelated universe. \n  The quest isn't just about static images; it's a gateway to new adventures. Golden Traits enhance VIP tasks, while Diamond Traits unlock special items, vehicles, and weapons, elevating gamers to new heights of glory. \n The Elemental Legends saga unfolds in RetroCraft, marking a legendary chapter in the metaverse. The adventure has just begun, and gamers eagerly await the next turn of the quest – the untold possibilities of the Elemental Legends NFT collection. `,
    },
    {
      id: 2,
      number: "2",
      question: "How can I mint?",
      answer: `1. Connect your C98 wallet or WalletConnect.\n 2. If you haven't already, register your Space ID domain on the BNB Chain. If your Space ID is already registered on the your wallet you're connected to, you can skip this step. \n 3. Click "Mint now." Each Elemental Legendary NFT costs 25.555 $RETRO tokens, so ensure you have enough tokens in your wallet. Click "Confirm & Mint" to begin minting.`,
    },
    {
      id: 3,
      number: "3",
      question:
        "What are the benefits of staking? What is Voxel Energy Token (VET)?",
      answer: `The Voxel Energy  Token (VET) is a reward earned by staking eligible RetroCraft NFTs, such as the "Elemental Legends" NFTs. With Voxel Energy Tokens, you can enjoy: \n - In-Game Items and Rewards: Earn exclusive in-game items, vehicles, weapons, and other rewards, enhancing your gaming experience within the RetroCraft universe. \n - Increased Pool Share: Staking contributes to an increased pool share, granting you a larger portion of rewards generated within the RetroCraft ecosystem. \n - Trading the token on PancakeSwap \n Also, staking your NFTs can potentially increase their long-term value, as participation in staking programs demonstrates commitment and support for the RetroCraft community and ecosystem.`,
    },
    {
      id: 4,
      number: "4",
      question: "How can I stake my eligible NFTs?",
      answer: `To stake your eligible NFTs, follow these steps: \n 1. Navigate to the staking page on the RetroCraft platform. \n 2. Choose the NFT you wish to stake from your collection. \n 3. Select the desired staking period, which ranges from 7 days to 60 days. \n 4. Click on the "Stake now" button to initiate the staking process.\n Please be aware that during the staking period, your NFT will be locked and unavailable for other purposes.`,
    },
    {
      id: 5,
      number: "5",
      question: "How can I unstake my NFTs?",
      answer: `To unstake your NFTs, follow these steps: \n 1. Once the staking period ends, navigate to the staking page on the RetroCraft platform. \n 2. Locate the NFT that you have staked and wish to unstake. \n 3. Click on the "Unstake" button associated with the NFT \n 4. Confirm the unstaking action.\n 5. Your NFT will then be successfully unstaked and available for other purposes.`,
    },
  ];

  const [showAnswers, setShowAnswers] = useState({});

  const toggleAnswer = (itemId) => {
    setShowAnswers((prevShowAnswers) => ({
      [itemId]: !prevShowAnswers[itemId],
    }));
  };

  return (
    <MainSection>
      <TextBoxDiv>
        <Image className="" src={textBox2} />
        <div>
          <h1 className="inner-text">
            Frequently Asked <span>Questions</span>
          </h1>
        </div>
      </TextBoxDiv>
      <MainContainer fluid>
        <Contentdiv>
          {faqdata.map((item, index) => (
            <MainDiv
              key={index}
              className={`${showAnswers[item.id] ? "open-div" : ""}`}
            >
              <div
                className="main-question-div"
                onClick={() => toggleAnswer(item.id)}
              >
                <div className="question-div">
                  <div className="number-div">
                    <h1>{item.number}</h1>
                  </div>
                  <h4>{item.question}</h4>
                </div>
                {showAnswers[item.id] ? (
                  <FaMinus fontSize={20} color="#fff" />
                ) : (
                  <FaPlus fontSize={20} color="#fff" />
                )}
              </div>
              {showAnswers[item.id] && (
                <div className="answer-div">
                  <h5>{item.answer}</h5>
                </div>
              )}
            </MainDiv>
          ))}
        </Contentdiv>
      </MainContainer>
    </MainSection>
  );
};

export default FaqComp;
